import { useAtomValue } from "jotai/index";
import { useMemo } from "react";

import { selectedClientServiceIdAtom, userAtom } from "@/store";

export const useGetCurrency = () => {
  const userAtomValue = useAtomValue(userAtom);
  const selectedClientServiceId = useAtomValue(selectedClientServiceIdAtom);

  return useMemo(
    () =>
      userAtomValue?.Services?.find(
        (service) => service.id === selectedClientServiceId
      )?.Organisation.currency || "",
    [userAtomValue?.Services, selectedClientServiceId]
  );
};
